<template>
  <header :class="`${toggleIsOpen && 'header--menu-is-open'} header`">
    <Container>
      <div class="header__wrapper">
        <div class="header__brand">
          <div class="header__organization" v-if="showLinks">
            {{ orgConfig("organization.name") }}
          </div>
          <div class="header__portal" v-if="showLinks">{{ $t("portal") }}</div>
        </div>
        <Toggle
          :toggle-is-open="toggleIsOpen"
          @handleClick="toggleIsOpen = !toggleIsOpen"
        />
        <div class="header__logo">
          <a href="//apitalks.com" target="_blank">
            <img src="@/assets/images/logo.svg" alt />
          </a>
        </div>
      </div>
    </Container>
    <Navbar :showLinks="showLinks" />
  </header>
</template>

<script>
import Toggle from "@/components/shared/Toggle.vue";
import Container from "@/components/homepage/Container";
import { localizedLink, orgConfig } from "@/mixins";
import Navbar from "./Navbar";

export default {
  mixins: [localizedLink, orgConfig],
  components: {
    Toggle,
    Navbar,
    Container
  },
  props: {
    showLinks: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      toggleIsOpen: false
    };
  }
};
</script>

<style lang="scss" scoped>
.header::after {
  content: "";
  z-index: 9997;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  pointer-events: none;
}

@media (max-width: $breakpoint-sm - 1) {
  .header--menu-is-open {
    &::after {
      content: "";
      z-index: 9997;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: $--color-landing-primary;
      pointer-events: all;
    }

    .container {
      position: relative;
      z-index: 9998;
    }

    .header__organization,
    .header__portal {
      color: $--color-white;
    }

    .navbar {
      position: absolute;
      left: 0;
    }
  }
}

.header__logo {
  margin-left: 30px;
  @media (max-width: $breakpoint-sm - 1) {
    display: none;
  }

  a {
    display: block;
  }

  img {
    display: bock;
  }
}

.header__wrapper {
  padding-top: rem(20);
  padding-bottom: rem(20);
  display: flex;
  justify-content: space-between;
  @include media("<navbar-sm") {
    padding-top: rem(16);
  }
}

.header__organization {
  font-size: rem(18);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: $--leter-spacing-xl;
  color: $--color-text-dark;
  line-height: 1.25;
}

.header__portal {
  letter-spacing: $--leter-spacing-xl;
  color: $--text-muted;
  @include media(">navbar-sm") {
    font-size: rem(16);
  }
}
</style>
